import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CaseCardData } from '../../models/case-card.model';
import { StatusBadgeComponent } from '../status-badge/status-badge.component';

@Component({
  selector: 'app-case-card',
  imports: [RouterLink, StatusBadgeComponent],
  templateUrl: './case-card.component.html',
  styleUrl: './case-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaseCardComponent {
  readonly caseItem = input.required<CaseCardData>();
}